// extracted by mini-css-extract-plugin
module.exports = {"LoadingScreen":"LoadingScreen_LoadingScreen__32OfY"};